var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLauncherItem',{attrs:{"title":_vm.$t('account'),"icon":_vm.$vuetify.icons.values.user,"routeName":"profile"}})}
var staticRenderFns = []

export { render, staticRenderFns }